import { buildSuccessResetPasswordPayload } from './buildSuccessResetPassword.js';
export const trackSuccessResetPassword = (params) => buildSuccessResetPasswordPayload(params);
//# sourceMappingURL=trackSuccessResetPasswordRequest.js.map